import { authAPI } from './api';
import Cookies from 'js-cookie';

export const checkAuthStatus = async () => {
  console.log('🔍 [DEBUG] Checking authentication status...');
  try {
    const token = Cookies.get('sankalvax_token');
    const user = Cookies.get('sankalvax_user');

    console.log('🔍 [DEBUG] Token exists:', !!token);
    console.log('🔍 [DEBUG] User exists:', !!user);

    if (!token || !user) {
      console.log('🔍 [DEBUG] No token or user found - returning false');
      return false;
    }

    console.log('🔍 [DEBUG] Verifying token with server...');
    // Verify token with server
    await authAPI.verifyToken(token);
    console.log('✅ [DEBUG] Token verification successful');
    return true;
  } catch (error) {
    console.error('❌ [DEBUG] Auth check failed:', error);
    console.log('🧹 [DEBUG] Clearing invalid auth data...');
    // Clear invalid auth data
    Cookies.remove('sankalvax_token');
    Cookies.remove('sankalvax_user');
    return false;
  }
};

export const getAuthToken = () => {
  return Cookies.get('sankalvax_token');
};

export const getAuthUser = () => {
  try {
    const user = Cookies.get('sankalvax_user');
    return user ? JSON.parse(user) : null;
  } catch (error) {
    console.error('Failed to parse user data:', error);
    return null;
  }
};

export const clearAuth = () => {
  Cookies.remove('sankalvax_token');
  Cookies.remove('sankalvax_user');
};

export const isTokenExpired = (token) => {
  if (!token) return true;
  
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const currentTime = Date.now() / 1000;
    return payload.exp < currentTime;
  } catch (error) {
    console.error('Failed to parse token:', error);
    return true;
  }
};

export const formatUserRole = (role) => {
  switch (role) {
    case 'admin':
      return 'Administrator';
    case 'user':
      return 'User';
    case 'viewer':
      return 'Viewer';
    default:
      return 'User';
  }
};

export const hasPermission = (userRole, requiredRole) => {
  const roleHierarchy = {
    'viewer': 1,
    'user': 2,
    'admin': 3
  };
  
  return roleHierarchy[userRole] >= roleHierarchy[requiredRole];
};